import React from "react";
import IconText from "../IconText";
import { CalendarIcon } from "../Icons";
import CloseFiled from "../Icons/CloseFiled";
import clsx from "clsx";
interface CustomProps {
  date: string;
  className?: string;
  onClear?: () => void;
  iconShow?: boolean;
  placeHolder?: string;
  textClassName?: string;
  hideCalenderIcon?: boolean;
  iconSize?: number;
}
const DatePill: React.FC<CustomProps> = ({
  date,
  onClear,
  iconShow,
  className,
  placeHolder,
  textClassName,
  hideCalenderIcon,
  iconSize,
}) => {
  return (
    <div className={`${className} p-4 flex justify-between items-center `}>
      <IconText
        className="gap-[4px]"
        text={date ? date : (placeHolder ?? "Date...")}
        textClassName={clsx(
          "text-sm font-normal text-secondary",
          textClassName,
        )}
        icon={
          hideCalenderIcon ? null : <CalendarIcon size={16} color="#79808A" />
        }
      />
      {iconShow && (
        <button
          onClick={onClear}
          className="text-gray-400 hover:text-gray-600 transition-colors ml-2"
        >
          <CloseFiled size={iconSize ? iconSize : 18} />
        </button>
      )}
    </div>
  );
};

export default DatePill;
